module.exports = __webpack_public_path__ + "static/img/surgery.b8962252.png";